<template>
    <div class="AudiobookHeader flex items-center justify-center">
        <ThemeSelector />
        <MenuMore :is-menu-visible="ui.rightSubmenu.opened" @toggle="toggleRightSubmenu" />
    </div>
</template>

<script>
'use strict';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import MenuMore from '../Components/MenuMore.vue';
import ThemeSelector from '../Components/ThemeSelector.vue';

export default {
    components: {
        MenuMore,
        ThemeSelector,
    },
    computed: {
        ...mapState(['ui', 'localizations', 'lang']),
        ...mapGetters(['onlyDesktopVisible', 'onlyMobileVisible']),
    },
    methods: {
        ...mapMutations(['toggleAudiobookAbout']),
        ...mapActions(['toggleSettings', 'toggleRightSubmenu']),
    },
};
</script>
